import request from '@/utils/request'

import store from '@/store'
let BASE_URL

const role = store.getters.userInfo.roles

if(role.indexOf('试听课学生') !== -1){
    BASE_URL = '/auditionstudent'
}else{
    BASE_URL = '/formalstudent'
}

// 获取班级列表
export function getClassList(params) {
	return request({
		url: BASE_URL + '/class_list',
		method: 'get',
		params
	})
}

// 获取作业
export function getHomework(params) {
  return request({
    url: BASE_URL + '/homework_list',
    method: 'get',
    params
  })
}

// 获取资料
export function getLibraryList(params) {
  return request({
    url: BASE_URL + '/library_list',
    method: 'get',
    params
  })
}

// 获取资料详情
export function getLibraryInfo(params) {
  return request({
    url: BASE_URL + '/library_info',
    method: 'get',
    params
  })
}

// 下载资料
export function downloadLibrary(params) {
  return request({
    url: BASE_URL + '/download_library_attach',
    method: 'get',
    // responseType: 'blob',
    params
  })
}

// ai tools
export function aiToolsList(params) {
  return request({
    url: BASE_URL + '/ai_tools_list',
    method: 'get',
    params
  })
}

// 报名夏令营
export function campUnlock(data) {
  return request({
    url: BASE_URL + '/camp_unlock',
    method: 'get',
    data
  })
}
